import { Disclosure } from "@headlessui/react";
import clsx from "clsx";

const DisclosureItem = ({ question, answer }) => {
    return (
        <Disclosure>
            {({ open }) => (
                <>
                    <Disclosure.Button className={clsx(
                        "w-full flex items-center justify-between bg-neutral-10 phone:py-4 tablet:py-5 py-[26.5px] px-0 md:px-6 text-left phone:text-[16px] text-heading-6 font-medium text-neutral-100 focus:outline-none focus-visible:ring",
                        !open ? "border-b border-neutral-30" : "",
                        open ? "!pb-4" : ""
                    )}>
                        <span className="phone:max-w-[272px] phone:leading-[27.2px]">{question}</span>
                        {open ?
                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.6665 10.5001H13.3332M18.3332 10.5001C18.3332 15.1025 14.6022 18.8334 9.99984 18.8334C5.39746 18.8334 1.6665 15.1025 1.6665 10.5001C1.6665 5.89771 5.39746 2.16675 9.99984 2.16675C14.6022 2.16675 18.3332 5.89771 18.3332 10.5001Z" stroke="#808896" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            :
                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.99984 7.16675V13.8334M6.6665 10.5001H13.3332M18.3332 10.5001C18.3332 15.1025 14.6022 18.8334 9.99984 18.8334C5.39746 18.8334 1.6665 15.1025 1.6665 10.5001C1.6665 5.89771 5.39746 2.16675 9.99984 2.16675C14.6022 2.16675 18.3332 5.89771 18.3332 10.5001Z" stroke="#808896" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>

                        }
                    </Disclosure.Button>
                    <Disclosure.Panel className={clsx(
                        "px-0 md:px-6 text-sm text-neutral-50 leading-[23.8px] pb-6 desktop:pb-6 tracking-text",
                        open ? "border-b border-neutral-30" : ""
                    )}>
                        {answer} <span className="text-primary-main font-semibold">See Articles</span>
                    </Disclosure.Panel>
                </>
            )}
        </Disclosure>
    );
};

export default DisclosureItem;